// Colour recipes of the report tiles. The thresholds stay where they were (in
// the page); these only turn a tone name into Tailwind classes.

/** Large metric cards (Operasyonel Genel Bakış). */
export const HERO_TONES = {
  blue: 'tw-border-sky-500/25 tw-bg-sky-500/[0.08] tw-text-sky-800 dark:tw-border-sky-400/20 dark:tw-bg-sky-400/10 dark:tw-text-sky-200',
  green: 'tw-border-emerald-500/25 tw-bg-emerald-500/[0.08] tw-text-emerald-800 dark:tw-border-emerald-400/20 dark:tw-bg-emerald-400/10 dark:tw-text-emerald-200',
  yellow: 'tw-border-amber-500/30 tw-bg-amber-400/[0.12] tw-text-amber-800 dark:tw-border-amber-400/20 dark:tw-bg-amber-400/10 dark:tw-text-amber-200',
  red: 'tw-border-rose-500/25 tw-bg-rose-500/[0.08] tw-text-rose-800 dark:tw-border-rose-400/20 dark:tw-bg-rose-400/10 dark:tw-text-rose-200',
  purple: 'tw-border-violet-500/25 tw-bg-violet-500/[0.08] tw-text-violet-800 dark:tw-border-violet-400/20 dark:tw-bg-violet-400/10 dark:tw-text-violet-200',
};

/** Same scale as the old cards: ≥ good → green, ≥ fair → yellow, else red. */
export const rateTone = (value, good, fair) => {
  if (value >= good) return 'green';
  if (value >= fair) return 'yellow';
  return 'red';
};

/** Text colours for counts. The page decides the meaning, these only style it. */
export const TEXT_TONES = {
  ok: 'tw-text-emerald-700 dark:tw-text-emerald-300',
  warn: 'tw-text-orange-600 dark:tw-text-orange-300',
  bad: 'tw-text-rose-600 dark:tw-text-rose-300',
  severe: 'tw-text-red-700 dark:tw-text-red-300',
  amber: 'tw-text-amber-700 dark:tw-text-amber-300',
  muted: 'tw-text-slate-700 dark:tw-text-slate-200',
};

// Hex colours the page logic attaches to metrics → text tone
const HEX_TONES = {
  '#c53030': 'bad',
  '#c05621': 'warn',
  '#9b2c2c': 'severe',
  '#744210': 'amber',
  '#276749': 'ok',
};

/** Text classes for a hex colour from the page logic (undefined → neutral). */
export const hexTone = (hex) => TEXT_TONES[HEX_TONES[hex] || 'muted'];

/** Badge for a percentage of problems: ≤10 green, ≤30 yellow, else red. */
export const issueRateBadge = (rate) => {
  if (rate <= 10) return 'tw-bg-emerald-500/15 tw-text-emerald-800 dark:tw-text-emerald-200';
  if (rate <= 30) return 'tw-bg-amber-400/20 tw-text-amber-800 dark:tw-text-amber-200';
  return 'tw-bg-rose-500/15 tw-text-rose-800 dark:tw-text-rose-200';
};

/** Shared look of a clickable metric (opens the issue details). */
export const CLICKABLE = 'tw-cursor-pointer tw-transition hover:-tw-translate-y-0.5 hover:tw-shadow-[0_14px_30px_-20px_rgba(15,23,42,0.5)] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal-500/50';
